var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form", [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("card-title-component", {
                attrs: { title: _vm.$t("contacts.addContact.title") }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "card-content" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "firstname-form-group",
                            label: _vm.$t("contacts.addContact.firstname"),
                            "label-for": "firstname-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "firstname-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t(
                                "contacts.addContact.firstname"
                              )
                            },
                            model: {
                              value: _vm.localFirstname,
                              callback: function($$v) {
                                _vm.localFirstname = $$v
                              },
                              expression: "localFirstname"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "name-form-group",
                            label: _vm.$t("contacts.addContact.name"),
                            "label-for": "name-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "name-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t("contacts.addContact.name")
                            },
                            model: {
                              value: _vm.localName,
                              callback: function($$v) {
                                _vm.localName = $$v
                              },
                              expression: "localName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c(
                        "b-form-group",
                        {
                          staticClass: "o-label",
                          attrs: {
                            id: "phone-form-group",
                            label: _vm.$t("contacts.addContact.phone"),
                            "label-for": "phone-input"
                          }
                        },
                        [
                          _c("b-form-input", {
                            staticClass: "o-form",
                            attrs: {
                              id: "phone-input",
                              type: "text",
                              required: "",
                              placeholder: _vm.$t("contacts.addContact.phone")
                            },
                            model: {
                              value: _vm.localPhone,
                              callback: function($$v) {
                                _vm.localPhone = $$v
                              },
                              expression: "localPhone"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col" })
                ])
              ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 button-div" },
            [
              _c(
                "b-button",
                {
                  staticClass: "cancel-button o-button",
                  on: { click: _vm.cancel }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("contacts.addContact.cancelButton")) +
                      "\n                "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "save-button o-button",
                  on: { click: _vm.addPet }
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$t("contacts.addContact.saveButton")) +
                      "\n                "
                  )
                ]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11c61a9c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11c61a9c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contacts/AddContactComponent.vue
// module id = null
// module chunks = 